import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { CustomAvatar, SvgContainer } from "../../../components";
import { LOCATION } from "../../../assets/icons";
import theme from "../../../theme/theme";

interface Props {
  item: any;
  onClick: () => void;
}

function BaraBossCard({ item, onClick }: Props) {
  return (
    <Stack
      direction="row"
      spacing={2}
      my={2}
      sx={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <CustomAvatar avatarStyle={{ borderRadius: 100 }} />
      <Box>
        <Typography fontSize={14}>{`${item.nom} ${item.prenom}`}</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <SvgContainer
            svg={LOCATION}
            width={12}
            color={theme.colors.dimgray + "80"}
          />
          <Typography fontSize={13} color="#9BA69C">
            {item.adresse}
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
}

export default BaraBossCard;
